import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CustomCarousel = ({ items }: any) => {
  const isSingleItem = items.length === 1;

  const sliderRef = useRef<any>(null);

  useEffect(() => {
    const updateHeights = () => {
      const slideEls = document.querySelectorAll(".slick-slide > div");
      let maxHeight = 0;

      slideEls.forEach(el => {
        const height = el.offsetHeight;
        if (height > maxHeight) maxHeight = height;
      });

      slideEls.forEach(el => {
        (el as HTMLElement).style.height = `${maxHeight}px`;
      });
    };

    setTimeout(updateHeights, 100);
    window.addEventListener("resize", updateHeights);
    return () => window.removeEventListener("resize", updateHeights);
  }, [items]);
  
  const settings = {
    dots: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1.05,
    slidesToScroll: 0.95,
    autoplay: true,
    centerMode: true,
    centerPadding: "16px 16px",
  };
  
  return isSingleItem ? (
    items[0]
  ) : (
    <Slider ref={sliderRef} {...settings}>
      {items && items.slice(0,5).map((item: any, index: number) => (
        <div className="pr-2 h-full" key={index}>{item}</div>
      ))}
    </Slider>
  );  
};

export default CustomCarousel;
